import { render, staticRenderFns } from "./SuitePackageList.vue?vue&type=template&id=74588e62&"
import script from "./SuitePackageList.vue?vue&type=script&lang=js&"
export * from "./SuitePackageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports